<template>
	<div class="physical-pos-transactions-container">
		<AppBottomSheet :z-index="1020" :force-width="transactionsBottomSheetWidth" :active="showTransactionsTable" @toggling-popup="v => $emit('toggling-popup', v)">
			<div class="transactions-content" v-if="showTransactionsTable">
				<div class="row total-transacted-row">
					<AppButton v-if="isNative" @click="showDailyCloseClick" outline :text="languageStore.getString('close')"/>
				</div>
				<TransactionsTable :hidden-filters="transactionsHiddenFilters" @failed-fetch="handleFetchError" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :z-index="1030" :force-width="transactionsBottomSheetWidth" :active="showDailyClose" @toggling-popup="toggleDailyBottomSheet">
			<PhysicalPosDailyClose v-if="isNative && showDailyClose" @show-error="m => $emit('show-error', m)" />
		</AppBottomSheet>
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import TransactionsTable from "@/console-new/components/shared/TransactionsTable.vue";
import AppButton from "@/shared/components/AppButton.vue";
import PhysicalPosDailyClose from "@/console-pos/components/PhysicalPosDailyClose.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useLanguageStore} from "@/shared/stores";
import {useAdministrationStore} from "@/console-new/stores";
import {useUserStore} from "@/user/stores";
import {isNative} from "@/shared/helpers/webapp";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const administrationStore = useAdministrationStore();
		const userStore = useUserStore();
		return {languageStore, administrationStore, userStore};
	},
	name: "PhysicalPosTransactions",
	emits: ["show-error", "toggling-popup"],
	components: {PhysicalPosDailyClose, AppButton, TransactionsTable, AppBottomSheet},
	mixins: [WindowWidth],
	props: {
		showTransactionsTable: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			startTimeClose: "00:00",
			endTimeClose: "23:59",
			dateClose: "",
			showDailyClose: false,
			transactionsHiddenFilters: {type: ["connect_order_pos", 'pos_order']},
		}
	},
	computed: {
		transactionsBottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		isNative() {
			return isNative();
		}
	},
	methods: {
		showDailyCloseClick() {
			let dayShift = this.userStore.currBusiness.day_shift || "03:00:00";
			dayShift = dayShift.includes(':') ? dayShift : '03:00:00';
			let dayShiftParts = dayShift.split(':');
			let dayShiftHour = Number(dayShiftParts[0]);
			dayShiftHour = !isNaN(dayShiftHour) ? dayShiftHour : 3;
			let dayShiftMinute = Number(dayShiftParts[1]);
			dayShiftMinute = !isNaN(dayShiftMinute) ? dayShiftMinute : 0;
			let todayShiftStart = new Date();
			todayShiftStart.setHours(dayShiftHour, dayShiftMinute, 0, 0);
			let todayShiftEnd = new Date();
			todayShiftEnd.setMinutes(todayShiftEnd.getMinutes() + 1);
			if(todayShiftStart.getTime() > new Date().getTime()) {
				todayShiftStart.setHours(0,0, 0, 0);
			}
			this.startTimeClose = (todayShiftStart.getHours() < 10 ? "0" : "") + todayShiftStart.getHours() + ":" + (todayShiftStart.getMinutes() < 10 ? "0" : "") + todayShiftStart.getMinutes();
			this.endTimeClose = (todayShiftEnd.getHours() < 10 ? "0" : "") + todayShiftEnd.getHours() + ":" + (todayShiftEnd.getMinutes() < 10 ? "0" : "") + todayShiftEnd.getMinutes();
			let today = new Date();
			let month = (today.getMonth() + 1);
			this.dateClose = today.getFullYear() + "-" + (month < 10 ? "0" : "") + month + "-" + (today.getDate() < 10 ? "0" : "") + today.getDate();
			this.showDailyClose = true;
		},
		toggleDailyBottomSheet(isOpen) {
			this.showDailyClose = isOpen;
		},
		handleFetchError(details) {
			if(details && details !== 'not_connected') {
				let message = this.languageStore.getString('try_later_error');
				if(details === 'auth_denied') {
					message = this.languageStore.getString('auth_denied_error');
				} else if(details === 'refund_limit_exceeded') {
					message = this.languageStore.getString('refund_limit_exceeded_error');
				}
				this.$emit("show-error", message);
			}
		},
	}
}
</script>

<style scoped lang="scss">
.total-transacted-row {
	align-items: center;
	justify-content: flex-end;
	padding-bottom: 10px;

	&>p {
		margin-right: auto;
	}

}
</style>